<template>
  <v-card>
    <v-toolbar height="45" flat color="primary" dark>
      <v-toolbar-title class="white--text"
        ><v-icon class="white--text" left>{{ icons.mdiAccountHardHat }}</v-icon> Add New Labor</v-toolbar-title
      >
    </v-toolbar>
    <v-tabs>
      <v-tab>
        <v-icon left>
          {{ icons.mdiPlus }}
        </v-icon>
        Add New Labor
      </v-tab>
      <v-tab>
        <v-icon left>{{ icons.mdiCardAccountDetails }}</v-icon>
        Pricing
      </v-tab>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-form class="multi-col-validation">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="inventory.description"
                    color="secondary"
                    label="Description"
                    dense
                    outlined
                    @change="getName"
                  ></v-text-field>
                  <input type="hidden" v-model="inventory.name" />
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    background-color="transparent"
                    v-model="inventory.notes"
                    color="secondary"
                    dense
                    label="Notes (Optional)"
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="inventory.inv_category_id"
                    :append-icon="icons.mdiDotsHorizontalCircleOutline"
                    :items="inventoryCategories"
                    item-value="inv_category_id"
                    item-text="name"
                    outlined
                    color="secondary"
                    dense
                    chips
                    deletable-chips
                    small-chips
                    label="Inventory Category"
                    :prepend-inner-icon="icons.mdiChartBox"
                    single-line
                    @click:append="addnewInventoryCategory"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="inventory.vendor_id"
                    :append-icon="icons.mdiDotsHorizontalCircleOutline"
                    :items="vendors"
                    item-value="vendor_id"
                    item-text="vendor_name"
                    outlined
                    color="secondary"
                    dense
                    chips
                    deletable-chips
                    small-chips
                    label="Vendor"
                    @click:append="$router.push({ name: 'addnewvendor' })"
                    :prepend-inner-icon="icons.mdiAccountMultipleOutline"
                    single-line
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-form class="multi-col-validation">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-layout>
                    <v-autocomplete
                      v-model="inventory.rate_id"
                      :items="rates"
                      item-value="rate_id"
                      item-text="name"
                      outlined
                      color="secondary"
                      dense
                      chips
                      deletable-chips
                      small-chips
                      label="Rates"
                      :prepend-inner-icon="icons.mdiPercentOutline"
                      single-line
                    ></v-autocomplete>
                    <v-btn @click.prevent="addnewRateModal" class="mx-1" tile color="primary">
                      <v-icon v-text="icons.mdiPlus"></v-icon>
                      Add Rate
                    </v-btn>
                  </v-layout>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <input type="hidden" name="rate" v-model="inventory.rate" readonly />
                  <v-text-field
                    v-model="inventory.hour"
                    color="secondary"
                    label="Hour"
                    dense
                    outlined
                    @change="computeHourRate"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    @change="getLaborItem"
                    v-model="inventory.labor_id"
                    :append-icon="icons.mdiDotsHorizontalCircleOutline"
                    :items="labors"
                    item-value="labor_id"
                    item-text="name"
                    outlined
                    color="secondary"
                    dense
                    chips
                    deletable-chips
                    small-chips
                    label="Labor Matrix"
                    :prepend-inner-icon="icons.mdiAccountMultipleOutline"
                    @click:append="$router.push({ name: 'laborMatrix' })"
                    single-line
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-radio-group v-model="inventory.multiplier" class="mt-n1" row>
                    <h3 class="mr-5">Hour Multiplier</h3>
                    <v-radio label="1x" value="1.00"></v-radio>
                    <v-radio
                      label="1.05x
"
                      value="1.05"
                    ></v-radio>
                    <v-radio label="1.10x" value="1.10"></v-radio>
                    <v-radio label="1.15x" value="1.15"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    :append-icon="icons.mdiClose"
                    v-model="inventory.multiplier"
                    dense
                    label="Multiplier x"
                    outlined
                    color="secondary"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="inventory.discount"
                    dense
                    label="Discount"
                    outlined
                    color="secondary"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="inventory.subtotal"
                    dense
                    label="SubTotal"
                    outlined
                    color="secondary"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-switch class="mt-n4" flat label="Should this be taxed?"></v-switch>
                  <v-switch class="mt-n3" flat label="Does this customer receive a discount?"></v-switch>
                  <v-switch class="mt-n3" flat label="Does this customer have a labor rate override?"></v-switch>
                  <v-switch class="mt-n3" flat label="Does this customer have a labor matrix override?"></v-switch>
                  <v-switch class="mt-n3" flat label="Does this customer have a pricing matrix override?"></v-switch>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" rounded @click.prevent="addNewPartInventory">
              <v-icon right light>{{ icons.mdiContentSave }}</v-icon>
              <span>Save</span>
            </v-btn>
            <v-btn color="secondary" rounded @click.prevent="$router.push({ name: 'inventory' })">
              <v-icon right light>{{ icons.mdiClose }}</v-icon>
              <span>Cancel</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <addnew-rate
      :dialog.sync="showAddNewRateDialog"
      @open-dialog="showAddNewRateDialog = true"
      @close-dialog="showAddNewRateDialog = false"
    ></addnew-rate>
    <add-inventorycategory
      :dialog.sync="showNewInventoryCategoryDialog"
      @open-dialog="showNewInventoryCategoryDialog = true"
      @close-dialog="showNewInventoryCategoryDialog = false"
    />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import AddNewRateDialog from '@/views/settings/rate/AddNewRate.vue'
import AddNewDialog from '@/views/inventorycategory/AddNewInventoryCategory.vue'
import EditDialog from '@/views/inventorycategory/EditInventoryCategory.vue'

import {
  mdiAccountTie,
  mdiCardAccountDetails,
  mdiAccountSupervisor,
  mdiCar,
  mdiPlus,
  mdiInformation,
  mdiContentSave,
  mdiBell,
  mdiCalendarAccount,
  mdiClose,
  mdiArchiveArrowDown,
  mdiTools,
  mdiCarInfo,
  mdiChartBox,
  mdiAccountMultipleOutline,
  mdiPercentOutline,
  mdiAccountHardHat,
  mdiDotsHorizontalCircleOutline,
} from '@mdi/js'

export default {
  components: {
    'addnew-rate': AddNewRateDialog,
    'add-inventorycategory': AddNewDialog,
    'edit-inventorycategory': EditDialog,
  },
  created: function() {
    this.getInventoryCategories()
    this.getLabors()
    this.getRates()
    this.getVendors()
    window.mitt.on('loadInventoryCategories', () => {
      this.getInventoryCategories()
    })
  },
  data() {
    return {
      inventoryCategories: [],
      labors: [],
      vendors: [],
      laborItems: [],
      rates: [],
      inventory: {
        item_type: 'Labor',
        name: '',
        description: '',
        inv_category_id: '',
        labor_id: '',
        cost: '0.00',
        retail_price: '',
        subtotal: '',
        quantity: '',
        rate: '',
        hour: '0',
        multiplier: '',
        discount: '',
        notes: '',
      },
      showAddNewRateDialog: false,
      showNewInventoryCategoryDialog: false,

      icons: {
        mdiAccountTie,
        mdiCardAccountDetails,
        mdiAccountSupervisor,
        mdiCar,
        mdiPlus,
        mdiInformation,
        mdiContentSave,
        mdiBell,
        mdiCalendarAccount,
        mdiClose,
        mdiArchiveArrowDown,
        mdiTools,
        mdiCarInfo,
        mdiChartBox,
        mdiAccountMultipleOutline,
        mdiPercentOutline,
        mdiAccountHardHat,
        mdiDotsHorizontalCircleOutline,
      },
    }
  },
  methods: {
    getInventoryCategories: function() {
      this.$store
        .dispatch('inventoryCategory/fetchInventoryCategories')
        .then(response => {
          this.inventoryCategories = this.fetchInventoryCategories
        })
        .catch(err => {
          console.log(err)
        })
    },
    addnewInventoryCategory: function() {
      this.showNewInventoryCategoryDialog = true
    },
    getVendors: function() {
      this.$store
        .dispatch('vendor/fetchVendors')
        .then(response => {
          this.vendors = this.fetchVendors
        })
        .catch(err => {
          console.log(err)
        })
    },
    getLabors: function() {
      this.$store
        .dispatch('labor/fetchLabors')
        .then(response => {
          this.labors = this.fetchLabors
        })
        .catch(err => {
          console.log(err)
        })
    },
    getRates: function() {
      this.$store
        .dispatch('rate/fetchRates')
        .then(response => {
          this.rates = this.fetchRates
        })
        .catch(err => {
          console.log(err)
        })
    },

    getLaborItem: function() {
      let multiplier

      this.$store
        .dispatch('inventory/fetchLaborItems', {
          labor_id: this.inventory.labor_id,
          hours: this.inventory.hour,
        })
        .then(response => {
          this.laborItems = this.fetchLaborItems
          this.inventory.multiplier = this.laborItems.multiplier
          this.computeHourRate()
        })
        .catch(err => {
          console.log(err)
        })
    },
    getName: function() {
      this.inventory.name = this.inventory.description
    },
    addNewPartInventory: function() {
      this.$store
        .dispatch(`inventory/storeNewInventoryItem`, this.inventory)
        .then(response => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          })

          Toast.fire({
            icon: 'success',
            title: 'Record added successfully',
          })
          this.$router.push({ name: 'inventory' })
        })
        .catch(error => {
          console.log(error)
        })
    },
    computeHourRate: function() {
      let SubTotal

      SubTotal = this.inventory.rate * this.inventory.multiplier * this.inventory.hour - this.inventory.discount
      this.inventory.subtotal = SubTotal.toFixed(2)
    },
    onRateChange: function(event) {
      this.getRateHours(event.target.value).then(response => (this.inventory.rate = response))
    },
    async getRateHours(value) {
      let promise = new Promise((resolve, reject) => {
        this.fetchRates.map(item => {
          if (item.rate_id == value) resolve(item.rates)
        })
      })
      return await promise
    },
    addnewRateModal: function() {
      this.showAddNewRateDialog = true
    },
  },

  computed: {
    ...mapGetters({
      fetchInventoryCategories: 'inventoryCategory/fetchInventoryCategories',
      fetchLabors: 'labor/fetchLabors',
      fetchVendors: 'vendor/fetchVendors',
      fetchLaborItems: 'inventory/fetchLaborItems',
      fetchRates: 'rate/fetchRates',
      fetchInventoryItems: 'inventory/fetchInventoryItems',
    }),
    onComputeRate: function() {
      return this.inventory.rate
    },
  },

  watch: {
    onComputeRate() {
      this.computeHourRate()
    },
  },
}
</script>

<style></style>
